import {
  IonCol,
  IonContent,
  IonGrid,
  IonImg,
  IonPage,
  IonRow,
  IonText,
} from "@ionic/react";
import { makePATCHRequest } from "../../request/rawRequest";
import { Techno } from "../../types/techno";
import "../IonColor/color.css";
import "../generalCSS/stylesheet.css";
import "./TechnoList.css";

interface ContainerProps {
  endpoint: string;
  pathLogo: string;
}

export const technosActive: Techno[] = [
  {
    name: "Pâtisserie",
    url: "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/Images/P%C3%A2tisserie.png",
    active: true,
    href: "pat",
  },
  {
    name: "Boulangerie",
    url: "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/Images/Boulangerie.png",
    active: true,
    href: "boul",
  },
  {
    name: "Premium",
    url: "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/Images/Premium+4.png",
    active: true,
    href: "pat",
    option: "premium=true",
  },
  {
    name: "Charcuterie",
    url: "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/Images/Charcuterie.png",
    active: true,
    href: "char",
  },
  {
    name: "Primeur",
    url: "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/Images/Bannie%CC%80re-De%CC%81lice%CC%81o-primeur(1).png",
    active: true,
    href: "prim",
  },
];

const Register: React.FC<ContainerProps> = ({ endpoint, pathLogo }) => {
  const technosDisable: Techno[] = [
    {
      name: "Chocolat",
      url: "https://randomwordgenerator.com/img/picture-generator/57e5d1464f53a414f1dc8460962e33791c3ad6e04e5074417c2f7cd3924fc7_640.jpg",
      active: false,
      href: "",
    },
    {
      name: "Cuisine",
      url: "https://randomwordgenerator.com/img/picture-generator/55e7d7464b55a914f1dc8460962e33791c3ad6e04e507440762e7adc9e45c3_640.jpg",
      active: false,
      href: "",
    },
  ];

  return (
    <IonPage className="register">
      <IonContent color="primary">
        <IonGrid>
          <IonRow className="ion-justify-content-center">
            <IonCol size-lg="5" size-sm="10">
              <IonRow className="ion-justify-content-center">
                <IonCol size-lg="4" size="6" size-sm="6">
                  <IonImg
                    style={{ marginTop: 50 }}
                    src={pathLogo}
                    alt="loginImage"
                    className="loginImg"
                  />
                </IonCol>
              </IonRow>
            </IonCol>
          </IonRow>
          <IonRow className="ion-justify-content-center">
            <IonCol id="technoList" size-lg="5" size-sm="10">
              {displayTitle()}
              {displayTechnoActive(technosActive)}
              {displaySeparator()}
              {displayTechnoDisabled(technosDisable)}
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};

const displayTitle = () => {
  return (
    <IonRow className="ion-justify-content-center">
      <IonCol size-sm="12" size-lg="7">
        <IonText color="black" className="ion-text-center">
          <h1 className="bold uppercase">Bienvenue</h1>
          <h5 className="bold">Quel Module voulez-vous étudier ?</h5>
        </IonText>
      </IonCol>
    </IonRow>
  );
};

export const displayTechnoActive = (
  arr: Techno[],
  size?: "12",
  req?: boolean
) => {
  return arr.map(function (techno, i, arrtech) {
    return (
      <IonRow className="ion-justify-content-center" key={i}>
        <IonCol
          size-sm={size ?? "12"}
          size-lg={size ?? "7"}
          className={
            "clickable techno-item techno-active " +
            (i === arrtech.length - 1 ? "last " : "")
          }
          style={{ backgroundImage: 'url("' + techno.url + '")' }}
          onClick={async function () {
            localStorage.setItem("techno", techno.href);
            if (req !== undefined && req === true) {
              await makePATCHRequest("/pole?pole=" + techno.href)
                .then((response) => {
                  window.location.reload();
                })
                .catch((error) => {
                  localStorage.removeItem("authToken");
                });
            } else {
              window.location.href =
                "/register" + (techno.option ? "?" + techno.option : "");
            }
          }}
        ></IonCol>
      </IonRow>
    );
  });
};

const displayTechnoDisabled = (arr: Techno[]) => {
  return arr.map(function (techno, i) {
    return (
      <IonRow className="ion-justify-content-center" key={i}>
        <IonCol
          size-sm="12"
          size-lg="7"
          className="techno-item techno-disable"
          style={{ backgroundImage: "url(" + techno.url + ")" }}
        >
          <IonRow className="ion-justify-content-start vertical-align">
            <IonText color="white">
              <h4 className="techno-name uppercase">{techno.name}</h4>
            </IonText>
          </IonRow>
        </IonCol>
      </IonRow>
    );
  });
};

const displaySeparator = () => {
  return (
    <IonRow className="ion-justify-content-center">
      <IonCol size-sm="12" size-lg="7">
        <IonText color="black" className="ion-text-start">
          <h5 className="bold">À venir ...</h5>
        </IonText>
      </IonCol>
    </IonRow>
  );
};

export default Register;
